module.exports = __webpack_public_path__ + "img/figures-10.1.afcd233b.png";